<template>
    <div class="w-100" v-if="fetcher.initialized">

        <div class="page-header" :class="{ 'active' : showPageHeader }">

            <div class="container-fluid">
                <div class="page-title">{{ pageTitle }}</div>
            </div>

        </div>

        <div class="page-body">

            <div class="container-fluid">
                <h1 class="mb-4">{{ pageTitle }}</h1>

                <div class="placeholder-glow w-100 d-none">
                    <span class="placeholder bg-info col-24 mb-4 rounded-2" style="height: 80px;"></span>
                    <span class="placeholder bg-info col-24 mb-4 rounded-2" style="height: 80px;"></span>
                </div>

                <div>

                    <div class="list mb-12" v-if="active_cards.length > 0">

                        <router-link tag="div" class="list-item" :to="linkTo('/cards/'+card.id)" :key="'acard'+card.id" v-for="card in active_cards">

                            <h3>{{ productAreaName(card.product_area_id) }} {{ card.punches_total }}x{{ card.product.duration.minutes }} min <img src="/images/card/list-headline-arrow-primary.svg" class="headline-arrow"></h3>

                            <p v-if="card.product_area_id == 2">{{ card.punchesLeft }}/{{ card.punches_total }} träningspass återstår</p>
                            <p v-else>{{ card.punchesLeft }}/{{ card.punches_total }} behandlingar återstår</p>

                        </router-link>

                    </div>

                    <div class="list mb-12" v-else>
                        
                        <p class="large-text mb-4">Du har inga aktiva klippkort. Köp ett nytt klippkort hos oss eller via din förmånsportal och boka direkt.</p>

                        <router-link class="btn btn-primary" :to="linkTo('/shop')" @click="matomoTrackEvent('Shop', 'Link', 'Cards')">Köp klippkort</router-link>
                    </div>

                    <h1 class="mb-4 text-dark" v-if="expired_cards.length > 0 || used_cards.length > 0">
                        Utgångna/nyttjade
                    </h1>

                    <div class="list">

                        <router-link tag="div" class="list-item" :to="linkTo('/cards/'+card.id)" :key="'ecard'+card.id" v-for="card in expired_cards">

                        <h3 class="text-dark mb-0">{{ productAreaName(card.product_area_id) }} {{ card.punches_total }}x{{ card.product.duration.minutes }} min <img src="/images/card/list-headline-arrow-dark.svg" class="headline-arrow"></h3>
                        <p>Gick ut {{ card.valid_to }}</p>

                        </router-link>

                        <router-link tag="div" class="list-item" :to="linkTo('/cards/'+card.id)" :key="'ucard'+card.id" v-for="card in used_cards">

                            <h3 class="text-dark mb-0">{{ productAreaName(card.product_area_id) }} {{ card.punches_total }}x{{ card.product.duration.minutes }} min <img src="/images/card/list-headline-arrow-dark.svg" class="headline-arrow"></h3>
                            <p v-if="card.product_area_id == 2">Inga träningspass återstår.</p>
                            <p v-else>Inga behandlingar återstår.</p>

                        </router-link>

                    </div>

                </div>

            </div>

        </div>

    </div>
</template>

<script>
import scrollMixin from '../../../shared/mixins/scrollMixin'
import fetcher from '../../../shared/mixins/fetcher'

export default {

    mixins: [
        scrollMixin,
        fetcher
    ],

    data () {
        return {
            pageTitle: 'Klippkort',
            showPageHeader: false,

            active_cards: [],
            used_cards: [],
            expired_cards: [],
            fetcher: {
                autoFill: [
                    'active_cards',
                    'used_cards',
                    'expired_cards'
                ]
            },

            registerModalVisible: false,
            clinicModalVisible: false,

            registeringStep2: false,
            loadingRegistering: false,
            registeringError: false,
            registeringCode: '',
            showRegisteredTreatment: false,

            activeCard: '',
            transitionName: 'slide'
        }
    },

    computed: {
        fetcherUrl () {
            return '/cards'
        }
    },

    methods: {

    }
}
</script>
